var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSun = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6.76 5.34-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41ZM1 11h3v2H1v-2Zm10-9.95h2V4h-2V1.05Zm8.04 2.495 1.408 1.407-1.79 1.79-1.407-1.408 1.789-1.789Zm-1.8 15.115 1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4ZM20 11h3v2h-3v-2Zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm-1 4h2v2.95h-2V20Zm-7.45-.96 1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8Z",
  fill: "#000"
})));
export default SvgSun;